const initialState = {
  driverList: null,
  loading: true
}

export default initialState
